import { useEffect, useState } from "react";
import Button from "../components/atoms/Button/Button";
import { supabase } from "../lib/supabase/supabaseClient";
import { ErrorCode, errorMessageTranslator } from "./authHelpers";
import { AuthError } from "@supabase/supabase-js";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n";

const LoginForm = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (i18n.language !== navigator.language) {
      i18n.changeLanguage(navigator.language);
    }
  }, [t]);

  const handleLogin = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
      window.location.href = "/";
    } catch (error: unknown) {
      if (error instanceof AuthError) {
        const errorMessage = errorMessageTranslator(error.code as ErrorCode);
        setError(errorMessage);
      } else {
        setError(t("errorWhileLoggingIn"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className="dui-auth-page" onSubmit={handleLogin}>
      <div className="dui-auth-logo">
        <b>Doktor</b>UI
      </div>
      <div className="dui-auth-form">
        <div>
          <div className="dui-auth-title">{t("loginTitle")}</div>
          {error && (
            <div className="dui-auth-error">
              <div className="dui-auth-error-text">{error}</div>
            </div>
          )}

          <div className="dui-auth-form-fields-wrapper">
            <div className="dui-auth-form-fields">
              <div className="dui-auth-field">
                <div className="dui-auth-field-label">{t("email")}</div>
                <input
                  className="dui-auth-field-input"
                  type="email"
                  placeholder={t("yourEmail")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="dui-auth-field">
                <div className="flex items-center">
                  <div>{t("password")}</div>
                </div>
                <input
                  className="dui-auth-field-input"
                  type="password"
                  placeholder={t("yourPassword")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <a href="/forgot-password" className="dui-auth-field-comment">
                  {t("forgotPassword")}
                </a>
              </div>
              <Button
                className="dui-auth-button"
                disabled={isLoading}
                onClick={handleLogin}
                corners="rounded"
                htmlType="submit"
              >
                {isLoading ? t("loggingIn") : t("login")}
              </Button>
            </div>
            <div className="dui-auth-form-footer">
              {t("dontHaveAccount")} <a href="/sign-up">{t("signUp")}</a>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
